export enum RockPaperScissorsGameStatus {
	WAITING = 'waiting',
	PLAYING = 'playing',
	WON = 'won',
	LOST = 'lost',
	DRAW = 'draw',
}

export enum RockPaperScissorsChoice {
	ROCK = 'rock',
	PAPER = 'paper',
	SCISSORS = 'scissors',
}
